import { ModelFilter } from '@volkswagen-onehub/library-services-marketingcode';
import { ServiceConfigurationV1 } from '@volkswagen-onehub/service-config-provider';
import { reportErrorSentry } from 'src/bff/report-error-sentry';
import { TrackingConfiguration } from '../tracking-types';
import { fetchMarketingCode } from 'src/bff/api/fetch-marketing-code';
export interface MarketingCodeHistory {
  marketingCode: string;
  marketingCodeConfig: TrackingConfiguration;
}
let marketingCodeHistory: MarketingCodeHistory[] = [];

export const getMarketingCode = async (
  marketingCode: string
): Promise<{ marketingCodeConfig: TrackingConfiguration; }> => {
  // await delayRequest();
  const offerInHistory = marketingCodeHistory.find((offer) => offer.marketingCode === marketingCode);

  if (offerInHistory) {
    return { marketingCodeConfig: offerInHistory.marketingCodeConfig };
  } else {
    const { marketingCodeConfig } = await receiveMarketingCode(marketingCode);
    const history: MarketingCodeHistory = { marketingCode, marketingCodeConfig };
    marketingCodeHistory.push(history);
    return { marketingCodeConfig };
  }
};

const getOption = (category: string, options: { category: string, code: string, description: string }[]) => {
  const option = options.find((option) => option.category==category);
  return { option };
};

const getModelFilter = (type: string, modelFilters: { id: string, text: string, type: string }[]) => {
  const modelFilter = modelFilters.find((modelFilter) => modelFilter.type==type);
  return { modelFilter };
};

class ErrorLoadStorageDataset extends Error {
  constructor(message:any) {
    super(message);
    this.name = 'ErrorLoadStorageDataset';
  }
}

export const receiveMarketingCode = async (
  marketingCode: string,
): Promise<{ marketingCodeConfig: TrackingConfiguration; }> => {

  try {
    const response = await fetchMarketingCode(marketingCode);
    
    const salesgroup = getOption("SALESGROUP",response.content.consolidatedData.options);
    const modelyear = getOption("MODELYEAR",response.content.consolidatedData.options);
    const type = getOption("TYPE",response.content.consolidatedData.options);
    const baseType = getOption("BASETYPE",response.content.consolidatedData.options);

    const equipmentLine = getModelFilter("EquipmentLine",response.content.consolidatedData.meta.modelFilter);

    const marketingCodeConfig: TrackingConfiguration = {
      SalesgroupId: salesgroup.option.code.replace('SALESGROUP:',''),
      SalesgroupName: salesgroup.option.description,
      EquipmentlineName: equipmentLine.modelFilter.text,
      ModelId: baseType.option.code.replace('BASETYPE:',''),
      ModelName: type.option.description,
      ModelYear: modelyear.option.code.replace('MODELYEAR:',''),
    };
    
    return { marketingCodeConfig };
  } catch (error) {
    const errorMkc = new ErrorLoadStorageDataset(error);
    reportErrorSentry(errorMkc);
    const marketingCodeConfig: TrackingConfiguration = null;
    return { marketingCodeConfig };
  }
};

/**
 * Necesitamos retrasar la request ya que se llama desde muchos sitios al mismo tiempo, por lo que se producen llamadas
 * innecesarias. Esta función simplemente espera a que de tiempo a resolver el marketing code y se la siguiente llamada
 * ya encuentre el resultado de la request anterior en el objeto de historia.
 */
export const delayRequest = async () =>
  new Promise((resolve) => {
    setTimeout(resolve, 1000);
  });
